import type { CreateBasicWorkspaceResponse } from '@otter-ai/recall-client';
import * as recallApi from '@otter-ai/recall-client';
import { useMutation } from '@tanstack/react-query';

export function useCreateBasicWorkspaceMutation({
  onSuccess,
  onError,
}: {
  onSuccess?: (data: CreateBasicWorkspaceResponse) => void;
  onError?: (error: Error) => void;
} = {}) {
  return useMutation({
    mutationFn: async () => {
      const response = await recallApi.createBasicWorkspace({
        throwOnError: true,
      });
      return response.data;
    },
    onSuccess,
    onError,
  });
}
